import { LocationDto } from "@app/data/management/models/location.dto";
import { SectorDto } from "@dashboard/modules/management/sector/model/sector.dto";
import { CurrentAccountDto } from "@dashboard/modules/finance-management/current-account/model/current-account.dto";
import { CompanyType } from "./company-type";

export class CompanyDto {
  public id?: number;
  public description?: string;
  public number?: number;
  public status?: string;
  public type?: CompanyType;
  public tax_num?: string;
  public tax_office?: string;
  public address?: string;
  public phone?: string;
  public phone2?: string;
  public fax_num?: string;
  public email_address?: string;
  public web_address?: string;
  public trade_register_num?: string;
  public mersis_num?: string;
  public country?: LocationDto;
  public region?: LocationDto;
  public state?: LocationDto;
  public city?: LocationDto;
  public county?: LocationDto;
  public sector?: SectorDto;
  eintegrator_type?: string;
  eintegrator_user_name?: string;
  eintegrator_user_password?: string;
  eintegrator_sign_logo?: string;
  einvoice_user_type?: string;
  einvoice_send_label?: string;
  einvoice_post_label?: string;
  einvoice_xslt_file?: string;
  einvoice_xslt_file_name?: string;
  edispatch_user_type?: string;
  edispatch_send_label?: string;
  edispatch_post_label?: string;
  edispatch_xslt_file?: string;
  edispatch_xslt_file_name?: string;
  earchive_user_type?: string;
  earchive_xslt_file?: string;
  earchive_xslt_file_name?: string;
  latitute?: number;
  langitute?: number;
  delivery_fee?: number;
  min_shopping_amount?: number;
  company_image?: string;
  carrier_company?: any;
  order_current_account?: CurrentAccountDto;
  center_company?: any;
  center_branch?: any;
  center_warehouse?: any;
  center_current_account?: CurrentAccountDto;
  local_current_account?: CurrentAccountDto;
  center_working_period?: any;
  post_code?: string;
  company_service_settings?: Array<any>;
}
